namespace app.tarefas.minhasTarefas {

    import IDialogService = ng.material.IDialogService;
    import IPromise = ng.IPromise;
    import MessagesService = app.support.messaging.MessagesService;
    import ExportarTarefasService = app.tarefas.minhasTarefas.ExportarTarefasService;
    import CamposExportacaoTarefa = app.tarefas.minhasTarefas.CamposExportacaoTarefa;

    export class ExportarTarefasController {

        public formato: boolean = false;

        public exportando: boolean = false;

        public camposExportacao: CamposExportacaoTarefa[] = [
            { nome: "title", descricao: "Nome da tarefa", isAtivo: true, tipo: 'text', funcaoDeFormatacao: '' },
            { nome: "claimDate", descricao: "Data de atribuição", isAtivo: true, tipo: 'date', funcaoDeFormatacao: '' },
            { nome: "startDate", descricao: "Data de criação", isAtivo: true, tipo: 'date', funcaoDeFormatacao: '' },
            { nome: "", descricao: "Data de conclusão/cancelamento", isAtivo: true, tipo: 'date', funcaoDeFormatacao: 'formatDataConclusaoCancelamento' },
            { nome: "extraInfo", descricao: "Informações extras", isAtivo: true, tipo: 'array', funcaoDeFormatacao: '' },
            { nome: "", descricao: "Resultado da conclusão/Justificativa do cancelamento", isAtivo: true, tipo: 'text', funcaoDeFormatacao: 'formatResultadoJustificativa' },
            { nome: "tags", descricao: "Rótulos", isAtivo: true, tipo: 'array', funcaoDeFormatacao: '' },
            { nome: "", descricao: "Situação final", isAtivo: true, tipo: 'text', funcaoDeFormatacao: 'formatResultadoFinal' },
            { nome: "assignee", descricao: "Usuário responsável", isAtivo: true, tipo: 'text', funcaoDeFormatacao: '' },
        ];

        /** @ngInject **/
        constructor(private $mdDialog: IDialogService,
            private exportarTarefasService: ExportarTarefasService,
            private messagesService: MessagesService,
            private tasks: ITask[],
			private usersNames: Map,
            private fromDate: string,
            private toDate: string,
            private fileName: string) {
        }

        public exportarHistoricoTarefas(formato: string): IPromise<void> {
            this.exportando = true;
            let camposPermitidos = this.camposExportacao.filter(i => i.isAtivo);
            let nomeRelatorio = this.montarNomeRelatorio(formato, this.fromDate, this.toDate);

            return this.exportarTarefasService
                .exportarHistoricoTarefas(this.tasks, this.usersNames, camposPermitidos, nomeRelatorio).then(() => {
                    this.messagesService.success("Exportação realizada com sucesso!", 4000);
                }, () => {
                    this.messagesService.error("Erro na exportação de resultados!");
                }).finally(() => {
                    this.exportando = false;
                    return this.fechar();
                });
        }

        public fechar(): void {
            this.$mdDialog.hide();
        }

        private montarNomeRelatorio(formato: string, dataInicial: string, dataFinal: string): string {
            let baseName = `${this.fileName}-${dataInicial}-a-${dataFinal}`;
            if (formato === 'Excel') {
                return `${baseName}.xlsx`
            }
            return `${baseName}.csv`
        }

        public isValid(): boolean {
            const camposInativos = this.camposExportacao.filter(field => !field.isAtivo);
            return this.formato && !this.exportando && camposInativos.length !== this.camposExportacao.length;
        }
    }

    angular
        .module("app.tarefas.minhas-tarefas")
        .controller("app.tarefas.minhas-tarefas.ExportarTarefasController", ExportarTarefasController);
}